// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2RHTu","content":"styles_content__1DxLw","checkbox":"styles_checkbox__fSCKt","checkboxLabel":"styles_checkboxLabel__Of5gX"};